/**
 * 群成员列表页懒加载壳（14.27b；GroupManageLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function GroupMembersLazy({ groupId }: { groupId: number }) {
  const { mod } = useLazyModule(() => import('./GroupMembersPage'));
  if (mod === null) return <div data-testid="group-members-loading-shell">加载中…</div>;
  return <mod.GroupMembersPage groupId={groupId} />;
}
